import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'

export const ImageLinkItemSchema = buildEntrySchemaFor('imageLinkItem', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      eyebrow: safeOptional(z.string()),
      heading: RichTextSchema,
      description: RichTextSchema,
      href: z.string(),
      label: z.string(),
      alt: safeOptional(z.string()),
      image: AssetSchema,
    }),
  ),
})
export type ImageLinkItem = z.infer<typeof ImageLinkItemSchema>
